// extracted by mini-css-extract-plugin
module.exports = {"offer":"styles_offer__9_G5z","inner":"styles_inner__rgYn0","browseButton":"styles_browseButton__QMBYL","categoriesGrid":"styles_categoriesGrid__XcD9u"};